<template>
	<div id="app">
		<!-- <Header></Header> -->
		<router-view />
		<!-- <Footer></Footer> -->
		<!-- <GoTop></GoTop> -->
	</div>
</template>

<script>
export default {
	data() {
		return {};
	}
};
</script>
<style>
/* 针对整个页面 */
body {
  overflow-x: hidden; /* 隐藏水平滚动条 */
}
</style>